<template>
  <span class="d-inline-block px-1" :style="requiredTagStyle">{{text || "必須"}}</span>
</template>

<script lang="ts" setup>

import { computed, CSSProperties, defineProps } from 'vue';
import { useTheme } from '@/composable/ui/useTheme';
import { Colors } from '@/store/theme.store';

const theme = useTheme();
const props = defineProps({
  size: {
    type: String as() => 'xs' |'sm' | 'md' | 'lg',
    default: 'sm',
  },
  bold: Boolean,
  text: String,
  color: { type: String as () => keyof Colors, default: 'error' },
  justify: {
    type: String as () => 'start' | 'center' | 'end',
    default: 'start',
  },
  requiredTag: {
    type: Boolean,
    default: false,
  },
});
const sizes = {
  xs: 14,
  sm: 16,
  md: 18,
  lg: 20,
};

const textAligns = {
  start: 'left',
  center: 'center',
  end: 'right',
};
const requiredTagStyle = computed((): CSSProperties => ({
  // 'font-size': `${sizes[props.size]}px`,
  fontSize: `12px`,
  minHeight: `18px`,
  fontWeight: 400,
  color: theme.resolveColor('white'),
  background: theme.resolveColor(props.color),
  textAlign: textAligns[props.justify] as CSSProperties['textAlign'],
  margin: 'auto 10px',
}));
</script>

<style scoped>

</style>
